

import { useEffect, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { FiHelpCircle } from 'react-icons/fi';
import { Link, useNavigate, useParams } from 'react-router-dom';
import InputBox from '../../../../Components/Input';
import SelectDropdown from '../../../../Components/InputSelect';
import Loader from '../../../../Components/Loader';
import ModalDailog from '../../../../Components/Modal';
import useMyAgencyData from '../../../../hooks/useMyAgencyData';
import { API_ENDPOINTS } from "../../../../utils/api";
import createAxiosInstance from "../../../../utils/axiosInstance";
import { formatToUSD } from '../../../../utils/formatters';
import { cleanObject, needReasonOptions } from '../../../../utils/helper';

const NeedsDetailsEdit = () => {
  const axiosInstance = createAxiosInstance();
  const myShelter = useMyAgencyData();
  const { needId } = useParams();
  const navigate = useNavigate();

  const [need, setNeedDetails] = useState<any>([]);
  const [isFeesModalOpen, setIsFeesModalOpen] = useState(false);
  const [isLoding, setIsLoding] = useState(true);
  const [defaultValues, setDefaultValues] = useState({
    assessments: [{
      amount: undefined,
      description: "",
      fee: undefined,
      needReason: "",
      numberOfBednight: undefined,
      originalAmount: undefined,
      referenceId: ""
    }],
    caseReferenceId: "",
  });

  const {
    register,
    watch,
    handleSubmit,
    setValue,
    formState: { errors },
    reset
  } = useForm<{
    assessments: {
      amount: number | null;
      description: string;
      fee: number | null;
      needReason: string;
      numberOfBednight: number;
      originalAmount: number;
      referenceId: string;
    }[];
    caseReferenceId: string;
  }>({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues,
  });

  const watchOriginalAmount = watch("assessments.0.originalAmount");
  const watchReferenceId = watch("assessments.0.referenceId");
  const watchNeedReason = watch("assessments.0.needReason");

  useEffect(() => {
    setValue("caseReferenceId", watchReferenceId);
  }, [watchReferenceId]);

  useEffect(() => {
    setValue("assessments.0.description", "");
  }, [watchNeedReason]);

  useEffect(() => {
    if (watchOriginalAmount && myShelter) {
      setValue("assessments.0.fee", watchOriginalAmount * (myShelter.details.fee / 100));
      setValue(
        "assessments.0.amount",
        (watchOriginalAmount * (myShelter.details.fee / 100)) + (watchOriginalAmount * 1),
      );
    } else {
      setValue("assessments.0.fee", null);
      setValue("assessments.0.amount", null);
    }
  }, [watchOriginalAmount, myShelter]);

  const handleFeesModal = () => {
    setIsFeesModalOpen(true);
  }

  const closeFeessModal = () => {
    setIsFeesModalOpen(false);
  }

  useEffect(() => {
    getNeedDetails();
  }, []);

  const getNeedDetails = async () => {
    try {
      const response = await axiosInstance.get(`${API_ENDPOINTS.SAFENIIGHT.GETRECENTNEEDS}/${needId}`);

      const data = response.data; // Extract the actual data

      reset({
        assessments: [{
          amount: data.assessments[0].amount,
          description: data.assessments[0].description,
          fee: data.assessments[0].fee,
          needReason: data.assessments[0].needReason,
          numberOfBednight: data.assessments[0].numberOfBednight,
          originalAmount: data.assessments[0].originalAmount,
          referenceId: data.assessments[0].referenceId
        }],
        caseReferenceId: data.caseReferenceId
      });

      setNeedDetails(data);
      setIsLoding(false);
    } catch (error) {
      setIsLoding(false);
      console.log(error);
    }
  };

  const submitHandler: SubmitHandler<any> = async (formData) => {
    try {
      setIsLoding(true);
      const data = cleanObject(formData);

      const needUpdate = await axiosInstance.put(
        `${API_ENDPOINTS.SAFENIIGHT.GETRECENTNEEDS}/${needId}`,
        data
      );

      if (needUpdate.status === 200) {
        setIsLoding(false);
        navigate(`/safenight/needs/need-details/${needId}`);
      }
    } catch (error) {
      setIsLoding(false);
      console.log(error);
    }
  }

  const erroHandler = (error: any) => {
    console.log(error);
  }

  return (
    <>
      {isLoding && <Loader />}
      <div className="container py-4 md:py-10 2xl:py-[70px] flex justify-center">
        <div className="w-full lg:w-2/3">
          <div className="card py-4">
            <div className="mb-4 text-gray-900 font-semibold text-sm md:text-base 2xl:text-xl">Alerts #{need?.sequenceId}</div>
            <form
              name="closeForm"
              onSubmit={handleSubmit(submitHandler, erroHandler)}
              noValidate
            >
              <div className="mb-4 md:mb-6 flex flex-wrap items-center gap-x-3 justify-center">
                <label htmlFor="CostOfRoom" className='block mb-1 md:mb-0 text-md font-medium text-gray-500 w-full md:w-40 md:text-end'>Cost of Room</label>
                <div className="w-full md:w-6/12">
                  <InputBox
                    type="number"
                    id='CostOfRoom'
                    value={watch("assessments.0.originalAmount")}
                    {...register("assessments.0.originalAmount", { required: true })}
                    disabled={true}
                  />
                </div>
              </div>
              <div className="mb-4 md:mb-6 flex flex-wrap items-center gap-x-3 justify-center">
                <label htmlFor="whatFees" className='block mb-1 md:mb-0 text-md font-medium text-gray-500 w-full md:w-40 md:text-end'> <span className='text-error' onClick={handleFeesModal}>What is this?</span> Fees</label>
                <div className="w-full md:w-6/12">
                  {formatToUSD(watch('assessments.0.fee') ?? undefined)}
                </div>
              </div>
              <div className="mb-4 md:mb-6 flex flex-wrap items-center gap-x-3 justify-center">
                <label htmlFor="whatFees" className='block mb-1 md:mb-0 text-md font-medium text-gray-500 w-full md:w-40 md:text-end'> Total Amount</label>
                <div className="w-full md:w-6/12">
                  {formatToUSD(watch('assessments.0.amount') ?? undefined)}
                </div>
              </div>
              <div className="mb-4 md:mb-6 flex flex-wrap items-center gap-x-3 justify-center">
                <label htmlFor="whatFees" className='block mb-1 md:mb-0 text-md font-medium text-gray-500 w-full md:w-40 md:text-end'> Reason</label>
                <div className="w-full md:w-6/12">
                  <SelectDropdown
                    options={needReasonOptions}
                    name="assessments.0.needReason"
                    placeholder="Choose an option"
                    labelIcon={<FiHelpCircle />}
                    value={watch("assessments.0.needReason")}
                    register={register}
                    setValue={setValue}
                  />
                  {errors?.assessments?.[0]?.needReason?.type === "required" && (
                    <label className="text-error">
                      This field is required.
                    </label>
                  )}
                </div>
              </div>
              {watch(`assessments.0.needReason`) === needReasonOptions[needReasonOptions.length - 1].value && (
                <div className="mb-6 flex items-center gap-3 justify-center">
                  <label htmlFor="description" className='block text-md font-medium text-gray-500 w-40 text-end'>Description</label>
                  <div className="w-6/12">
                    <InputBox
                      type="text"
                      id='description'
                      {...register("assessments.0.description", { required: true })}
                    />
                    {errors?.assessments?.[0]?.description?.type === "required" && (
                      <label className="text-error">
                        This field is required.
                      </label>
                    )}
                  </div>
                </div>
              )}
              <div className="mb-4 md:mb-6 flex flex-wrap items-center gap-x-3 justify-center">
                <label htmlFor="NumberofBedNights" className='block mb-1 md:mb-0 text-md font-medium text-gray-500 w-full md:w-40 md:text-end'>Number of Bed Nights</label>
                <div className="w-full md:w-6/12">
                  <InputBox
                    type="number"
                    id='NumberofBedNights'
                    onKeyDown={(e: any) => {
                      if (e.key === '-' || e.key === 'e' || e.key === '.') {
                        e.preventDefault();
                      }
                    }}
                    value={watch("assessments.0.numberOfBednight")}
                    {...register("assessments.0.numberOfBednight", {
                      min: {
                        value: 1,
                        message: "Value must be greater than or equal to 1"
                      },
                      required: true
                    })}
                  />
                  {errors?.assessments?.[0]?.numberOfBednight?.type === "required" && (
                    <label className="text-error">
                      Please enter number of beds in numeric form.
                    </label>
                  )}
                  {errors?.assessments?.[0]?.numberOfBednight?.type === "min" && (
                    <label className="text-error">
                      Number of Bed Nights must be greater than or equal to 1
                    </label>
                  )}
                </div>
              </div>
              <div className="flex flex-wrap items-center gap-x-3 justify-center">
                <label htmlFor="ReferenceId" className='block mb-1 md:mb-0 text-md font-medium text-gray-500 w-full md:w-40 md:text-end'>Reference ID</label>
                <div className="w-full md:w-6/12">
                  <InputBox
                    type="text"
                    id='ReferenceId'
                    value={watch("assessments.0.referenceId")}
                    {...register("assessments.0.referenceId")}
                  />
                </div>
              </div>
              <div className="flex justify-center gap-3">
                <Link to={`/safenight/needs/need-details/${needId}`} className="btn btn-outline-gray py-2.5 mt-4">
                  Cancel
                </Link>
                <button
                  className="btn btn-primary py-2.5 mt-4"
                  type='submit'
                >
                  Save Alert
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <ModalDailog isOpen={isFeesModalOpen} onClose={closeFeessModal} title="About fees" modalClassName="md:max-w-lg lg:max-w-lg" backButton="Close">
        <p className='text-sm 2xl:text-lg text-gray-600'>Payment processing fees are automatically calculated and added to the total amount requested to ensure that donations cover the full cost of the hotel room.</p>
        <p className='text-sm 2xl:text-lg text-gray-600 font-semibold mt-3'>Total Amount = Cost of Room + Fees</p>
      </ModalDailog>
    </>
  )
}

export default NeedsDetailsEdit